import React from 'react';
import { themr } from 'react-css-themr';
import theme from './CustomizedAxisTick.scss';
import classnames from 'classnames';

const CustomizedAxisTick = props => {
    const {
        x,
        y,
        height,
        width,
        totalTicks,
        payload,
        rotateTicks,
        useEllipsis,
        xAxis,
        yAxis,
        tickFormatter,
        relativeHeight,
        relativeWidth,
        theme
    } = props;
    let widthPerTick = width / totalTicks;
    let transform = `translate(${x - widthPerTick / 2},${y})`;
    if (rotateTicks) {
        widthPerTick = height * 1.2;
        transform = `translate(${
            x - widthPerTick
        },${y}) rotate(-30, ${widthPerTick}, 0)`; // some approximation
    }
    const lineHeight = 11;
    const tickText = tickFormatter
        ? tickFormatter(payload.value)
        : payload.value;

    return useEllipsis ? (
        <svg xmlns="http://www.w3.org/2000/svg">
            <foreignObject
                transform={transform}
                width={widthPerTick}
                height={height}
            >
                <div
                    className={classnames(theme.tick, {
                        [theme.doubleWidth]: relativeWidth >= 1.5,
                        [theme.doubleHeight]: relativeHeight >= 1.5,
                        [theme.rotateTicks]: rotateTicks
                    })}
                    xmlns="http://www.w3.org/1999/xhtml"
                >
                    <span className={theme.text} title={tickText}>
                        {tickText}
                    </span>
                </div>
            </foreignObject>
        </svg>
    ) : (
        <text
            height={height}
            width={width}
            x={yAxis ? x - 2 : x}
            y={yAxis ? y + 2 : y + lineHeight}
            fontSize={relativeHeight > 1.5 ? 10 : 9}
            className={classnames(
                'recharts-text',
                'recharts-cartesian-axis-tick-value',
                theme.chartTick,
                {
                    [theme.doubleWidth]: relativeWidth >= 1.5,
                    [theme.doubleHeight]: relativeHeight >= 1.5
                }
            )}
            textAnchor={xAxis ? 'middle' : 'end'}
            style={{ pointerEvents: 'none' }}
        >
            {tickFormatter ? tickFormatter(payload.value) : payload.value}
        </text>
    );
};

export default themr('AxisTick', theme)(CustomizedAxisTick);
